import Phaser from "phaser"
import { calculateScaleFactor } from "../config/scaling"
import { checkLocalSavedData, playUnlockPlanetAnimation } from "../helpers/levelManager"
import { planetsScroller } from "../helpers/planetScrollerFunction"
import { displayInstructions } from "../helpers/levelManager"
import { saveCurrentPlanetLocally } from "../helpers/levelManager"
import {
	saveCurrentMiniLevelLocally,
	playUISound,
} from "../helpers/levelManager"
import { GameAnalytics } from "gameanalytics"
import {
	setAllAlertsToFalse,
	saveEmailsOpenedLocally,
} from "../helpers/levelManager"
import { MediclinicAPI } from "../helpers/apiHandler"
export default class PlanetSelector extends Phaser.Scene {
	constructor() {
		super({ key: "PlanetSelector" })
	}

	init() {
		this.sceneW = this.cameras.main.width
		this.sceneH = this.cameras.main.height

		const scalingData = calculateScaleFactor(this)
		this.scaleFactor = scalingData.scaleFactor
		this.safeZoneX = scalingData.safeZoneX
		this.safeZoneY = scalingData.safeZoneY
		this.safeZoneWidth = scalingData.safeZoneWidth
		this.safeZoneHeight = scalingData.safeZoneHeight

		this.xOffset = 500
		this.planetsGroup = null

		this.loadSavedData()

		this.apiHandler = new MediclinicAPI()

		this.planetPressed = false
	}

	loadSavedData() {
		this.savedUserData = checkLocalSavedData()
		this.savedLevel = this.savedUserData?.userLevel || 0
		this.savedOrnament = this.savedUserData?.customization?.ornament || 0
		this.savedMiniLevel = this.savedUserData?.userMiniLevel || 0
		this.currentPlanet = this.savedUserData?.currentPlanet || 1
		this.completedPlanets = this.savedUserData?.planetsCompleted || 0
		this.planetsUnlockAnimationShown = this.savedUserData?.planetsUnlockAnimationShown || []
		this.userID = this.savedUserData?.userID || null
		console.log("=== LOAD SAVED DATA ===")
		console.log("Completed Planets:", this.completedPlanets)
		console.log("Current Planet:", this.currentPlanet)
		console.log("Planets with animation shown:", this.planetsUnlockAnimationShown)
		console.log("User ID:", this.userID)
	}

	preload() {
		this.savedUserData = checkLocalSavedData()
		this.savedLevel =
			this.savedUserData === null ? 0 : this.savedUserData.userLevel
		this.savedMiniLevel =
			this.savedUserData === null ? 0 : this.savedUserData.userMiniLevel
	}

	create() {
		this.planetIndex = 0
		console.log('DOM elements check:');
		console.log('Overlay:', document.querySelector('.tutorial-container'));
		console.log('Dropdown:', document.getElementById('tutorial-dropdown-container'));
		console.log('Scrollbar:', document.getElementById('tutorial-scrollbar-container'));
		console.log('Tutorial step:', document.getElementById('tutorial-step-01'));
		const dropdownContainer = document.getElementById('tutorial-dropdown-container');
		if (dropdownContainer) {
			dropdownContainer.remove();
		}
		this.soundManager = this.scene.get("GameUI").soundManager
		console.log("Saved Level: " + this.savedLevel)
		this.soundManager.playMusic("driftingInSpace", { volume: 0.5 })

		this.completedPlanets =
			this.savedUserData === null ? 0 : this.savedUserData.planetsCompleted
		console.log("Completed Planets: " + this.completedPlanets)

		this.unlockedPlanets = this.completedPlanets + 1
		this.planetData = this.cache.json.get("userGameData")

		this.checkPlayUnlockAnimation()

		this.createBackground()
		this.createPlanets()
		this.handleCameraEffects()
		this.showInstructionsIfNeeded()

		// Play animation on the planet that was just completed
		console.log("=== ANIMATION CHECK ===")
		console.log("Completed Planets:", this.completedPlanets)
		console.log("Animations shown for:", this.planetsUnlockAnimationShown)
		
		if (this.completedPlanets > 0) {
			// Ensure planetsUnlockAnimationShown is initialized as an array
			if (!this.planetsUnlockAnimationShown || !Array.isArray(this.planetsUnlockAnimationShown)) {
				this.planetsUnlockAnimationShown = []
			}

			const justCompletedPlanet = this.completedPlanets
			
			// Only show unlock animation if we haven't shown it for this completed planet yet
			if (!this.planetsUnlockAnimationShown.includes(justCompletedPlanet)) {
				console.log(`✓ Playing unlock animation for completed Planet ${justCompletedPlanet}`)
				
				// Calculate the index of the completed planet in the planetsGroup
				const planetIndex = (justCompletedPlanet - 1) * 2
				this.planetIndex = justCompletedPlanet
				playUnlockPlanetAnimation(this, {
					xPos: this.planetsGroup.getChildren()[planetIndex].x,
					yPos: this.planetsGroup.getChildren()[planetIndex].y,
				}, () => {
					// Mark as shown after animation completes
					console.log(`Animation completed, marking planet ${justCompletedPlanet} as shown`)
					this.markUnlockAnimationShown(justCompletedPlanet)
				})
			} else {
				console.log(`✗ Animation already shown for planet ${justCompletedPlanet}, skipping`)
			}
		}
	}

	createBackground() {
		this.bg = this.add
			.image(this.sceneW / 2, this.sceneH / 2, "spaceBG")
			.setOrigin(0.5)
			.setScale(this.scaleFactor * 0.25)
	}

	createPlanets() {
		const planets = this.planetData.planets
		this.planetsGroup = this.add.group()

		// Iterate through the planets and create their graphics
		planets.forEach((planetData, index) => {
			this.createPlanet(planetData, index)
		})

		//add more planets info
		this.addPlanetInfo()

		this.addVisibleEdge()

		// Add the planet edge image
		this.addPlanetEdge()

		// Initialize planets scroller
		planetsScroller.call(this)
	}

	createPlanet(planetData, index) {
		const yPosList = [-40, 30, -30, 40]
		const yPosListLength = yPosList.length
		// Calculate planet position
		const x = this.safeZoneX + index * (175 * this.scaleFactor)
		const y =
			this.safeZoneY +
			this.safeZoneHeight * 0.5 +
			yPosList[index % yPosListLength] +
			20 * this.scaleFactor

		// Create planet image
		const planet = this.add
			.image(x + 150, y, "planet0" + (index + 1))
			.setInteractive()
			.setOrigin(0.5)
			.setScale(this.scaleFactor * 0.5)
			.setDepth(2)

		// Determine planet status based on user's progress
		const planetStatus = this.determinePlanetStatus(index)
		planet.planetStatus = planetStatus

		// Create status indicator
		const statusIndicator = this.createStatusIndicator(
			planet,
			planetStatus,
			index,
		)

		// Add planet and status indicator to group
		this.planetsGroup.add(planet)
		if (statusIndicator) {
			this.planetsGroup.add(statusIndicator)
		}

		// Set up interaction events
		this.setupPlanetInteraction(planet, index)
	}

	determinePlanetStatus(index) {
		if (index < this.completedPlanets) {
			return "completed"
		} else if (
			index === this.completedPlanets &&
			index <= this.unlockedPlanets &&
			index != 3
		) {
			return "active"
		} else {
			return "locked"
		}
	}

	createStatusIndicator(planet, status, index) {
		let statusIndicator = null

		switch (status) {
			case "completed":
				statusIndicator = this.add
					.image(planet.x, planet.y, "planetComplete")
					.setOrigin(0.5)
					.setScale(this.scaleFactor * 0.5)
					.setDepth(2)
				break

			case "active":
				statusIndicator = this.add
					.image(planet.x, planet.y, "planetActive")
					.setOrigin(0.5)
					.setScale(this.scaleFactor * 0.5)

				// Create a tween to make the planet pulse
				this.tweens
					.add({
						targets: statusIndicator,
						scale: statusIndicator.scale + statusIndicator.scale / 3,
						duration: 1000,
						ease: "Linear",
						yoyo: true,
						repeat: -1,
					})
					.play()
				break

			case "locked":
				statusIndicator = this.add
					.image(planet.x, planet.y, "planetLocked")
					.setOrigin(0.5)
					.setScale(this.scaleFactor * 1.5)
					.setDepth(2)
					.setVisible(false)

				// Apply tint to locked planets
				//planet.setTint(this.calculateTint(0x3e27be, 0xffffff, 0.85))
				planet.setTexture("planet0" + (index + 1) + "Locked")
				break
		}

		return statusIndicator
	}

	checkPlayUnlockAnimation() {
		// Ensure planetsUnlockAnimationShown is initialized
		if (!Array.isArray(this.planetsUnlockAnimationShown)) {
			this.planetsUnlockAnimationShown = []
		}

		// Only sync for planets BEFORE the most recently completed one
		// This allows the most recently completed planet's animation to play
		// We mark planets 1 through (completedPlanets - 1) as shown, but NOT completedPlanets itself
		if (this.completedPlanets >= 1) {
			for (let i = 1; i < this.completedPlanets; i++) {
				if (!this.planetsUnlockAnimationShown.includes(i)) {
					this.planetsUnlockAnimationShown.push(i)
				}
			}

			// Save the updated data locally if any planets were added
			if (this.planetsUnlockAnimationShown.length > 0) {
				const savedData = checkLocalSavedData()
				if (savedData) {
					savedData.planetsUnlockAnimationShown = this.planetsUnlockAnimationShown
					localStorage.setItem("userData", JSON.stringify(savedData))
					console.log("Updated planetsUnlockAnimationShown:", this.planetsUnlockAnimationShown)
				}
			}
		}
	}

	markUnlockAnimationShown(planetIndex) {
		console.log(`=== MARKING PLANET ${planetIndex} AS SHOWN ===`)
		// Ensure array is initialized
		if (!Array.isArray(this.planetsUnlockAnimationShown)) {
			this.planetsUnlockAnimationShown = []
		}

		// Add to local array (check prevents duplicates)
		if (!this.planetsUnlockAnimationShown.includes(planetIndex)) {
			this.planetsUnlockAnimationShown.push(planetIndex)
			console.log(`Added planet ${planetIndex} to local array:`, this.planetsUnlockAnimationShown)
		}

		// Update saved data
		const savedData = checkLocalSavedData()
		if (savedData) {
			// Ensure the saved data also has the array initialized
			if (!Array.isArray(savedData.planetsUnlockAnimationShown)) {
				savedData.planetsUnlockAnimationShown = []
			}
			savedData.planetsUnlockAnimationShown = this.planetsUnlockAnimationShown
			localStorage.setItem("userData", JSON.stringify(savedData))
			console.log(`✓ Planet ${planetIndex} saved to localStorage`)
			console.log("Saved data now contains:", savedData.planetsUnlockAnimationShown)
		} else {
			console.log(`✗ ERROR: Could not save - no saved data found`)
		}
	}

	calculateTint(tintColor, noTint, blendFactor) {
		const r = Math.floor(
			((tintColor >> 16) & 0xff) * blendFactor +
			((noTint >> 16) & 0xff) * (1 - blendFactor),
		)
		const g = Math.floor(
			((tintColor >> 8) & 0xff) * blendFactor +
			((noTint >> 8) & 0xff) * (1 - blendFactor),
		)
		const b = Math.floor(
			(tintColor & 0xff) * blendFactor + (noTint & 0xff) * (1 - blendFactor),
		)
		return (r << 16) | (g << 8) | b
	}

	setupPlanetInteraction(planet, index) {
		let pressStartTime = 0

		planet.on("pointerdown", (pointer) => {
			pressStartTime = pointer.downTime
		})

		planet.on("pointerup", (pointer) => {
			if (planet.planetStatus === "locked") {
				console.log("UnPRESSABLE")
				return
			}

			const pressDuration = pointer.upTime - pressStartTime
			if (pressDuration < 150) {
				console.log("Open Planet: " + parseInt(index + 1))
				playUISound(this, this.soundManager, "Click-pop1", 0.25)
				// GameAnalytics.addDesignEvent("user_login")
				// GameAnalytics.addDesignEvent("session_start")
				saveCurrentPlanetLocally(index + 1)
				saveCurrentMiniLevelLocally(0)
				this.loadSavedData()
				this.startCockpitScene()
				this.sendAnalyticsEvent()
				setAllAlertsToFalse()
				const emailsToOpen = [0, 2, 2]
				saveEmailsOpenedLocally(emailsToOpen[index])
			}
		})
	}

	//GAME ANALYTICS FOR LEVEL/PLANET ENTRY
	async sendAnalyticsEvent() {
		const GAME_KEY = process.env.GAME_ANALYTICS_GAME_KEY
		const SECRET_KEY = process.env.GAME_ANALYTICS_SECRET_KEY

		GameAnalytics.configureUserId(this.userID)
		GameAnalytics.initialize(GAME_KEY, SECRET_KEY)

		const customizationData = {
			playerId: this.savedUserData.userID,
			tribe: this.savedUserData.customization.tribe,
			rocket: this.savedUserData.customization.rocket,
			ornament: this.savedUserData.customization.ornament,
		}

		console.log("Customization Data: YeeeyPee ========> ", customizationData)

		const timestamp = Date.now()
		localStorage.setItem("levelStartTime", timestamp.toString())

		const milestoneCodes = ["C1.5.1", "C1.5.6"]

		try {
			if (this.currentPlanet === 1) {
				for (const code of milestoneCodes) {
					await this.apiHandler.recordMilestoneCompletion(this.userID, code)
					await this.apiHandler.recordCustomization(customizationData)
				}
			}
		} catch (error) {
			console.error("Error recording milestone(s):", error)
		}

		if (!window._loginLogged) {
			const isNewUser = !localStorage.getItem("hasPlayedBefore")

			GameAnalytics.addDesignEvent(
				`user_login:${isNewUser ? "new" : "returning"}`,
			)

			// GameAnalytics.addDesignEvent(
			// 	`level${this.currentPlanet}_start:${this.userID}:${this.currentPlanet}:${timestamp}`,
			// )
			GameAnalytics.addDesignEvent(`game_startup:${this.userID}:${timestamp}`)
			GameAnalytics.addDesignEvent(`dau_tracking:${this.userID}`)

			GameAnalytics.addDesignEvent("session_start")

			// GameAnalytics.addProgressionEvent("Start", `planet_${this.currentPlanet}`)

			if (isNewUser) {
				localStorage.setItem("hasPlayedBefore", "true")
			}
			window._loginLogged = true
		} else {
			GameAnalytics.addProgressionEvent("Start", `planet_${this.currentPlanet}`)
		}
	}

	startCockpitScene() {
		if (this.planetPressed) return
		this.planetPressed = true
		this.loadingScene = this.scene.get("LoadingScene")

		// Create full-screen overlay
		// const overlay = this.add.rectangle(
		// 	this.sceneW / 2,
		// 	this.sceneH / 2,
		// 	this.sceneW,
		// 	this.sceneH,
		// 	0x000000,
		// 	0
		// )
		// .setDepth(10)
		const overlay = this.add
			.image(this.sceneW / 2, this.sceneH / 2, "spaceBG")
			.setOrigin(0.5)
			.setScale(this.scaleFactor * 0.25)
			.setTint(0x000000)
			.setAlpha(0)
			.setDepth(50)

		// Create loading text with animated dots
		const loadingText = this.add
			.text(this.sceneW / 2, this.sceneH / 2, "Loading", {
				fontFamily: "Space Grotesk",
				fontWeight: 700,
				fontStyle: "bold",
				fontSize: 32 * this.scaleFactor,
				color: "#FFFFFF",
			})
			.setOrigin(0.5)
			.setDepth(51)
			.setAlpha(0)

		// Animate dots in the loading text
		let dotCount = 0
		const dotAnimation = this.time.addEvent({
			delay: 500,
			repeat: -1,
			callback: () => {
				dotCount = (dotCount + 1) % 4
				loadingText.setText('Loading' + '.'.repeat(dotCount))
			}
		})

		// Fade in the overlay and loading text
		this.tweens.add({
			targets: overlay,
			alpha: 1,
			duration: 300,
			ease: 'Power2.easeOut',
			onComplete: () => {
				// Show loading text after overlay is visible
				this.tweens.add({
					targets: loadingText,
					alpha: 1,
					duration: 200,
					ease: 'Power2.easeOut'
				})
			}
		})

		// Load planet and transition when ready
		this.loadingScene.ensurePlanetLoaded(this, this.currentPlanet, () => {
			// Stop the dot animation
			dotAnimation.destroy()

			// Start the actual scene transition
			this.loadScene()
		})
	}

	loadScene() {
		this.scene.start("landingScene")

		//Debug
		// this.scene.start("CockpitScene")
		// this.scene.start("TabletScene")
		// this.scene.launch("TabletUI")
	}

	addPlanetInfo() {
		const planets = this.planetsGroup.getChildren()
		const lastPlanet = planets[planets.length - 1]

		const planetInfo = this.add
			.image(
				lastPlanet.x +
				(lastPlanet.width * this.scaleFactor) / 2 +
				200 * this.scaleFactor,
				lastPlanet.y,
				"morePlanets",
			)
			.setScale(this.scaleFactor * 0.3)
			.setDepth(20)

		this.planetsGroup.add(planetInfo)
	}

	addVisibleEdge() {
		const planets = this.planetsGroup.getChildren()
		const lastPlanet = planets[planets.length - 1]

		const planetEdge = this.add
			.image(
				lastPlanet.x +
				(lastPlanet.width * this.scaleFactor) / 2 -
				350 * this.scaleFactor,
				lastPlanet.y,
				"planetEdge",
			)
			.setScale(this.scaleFactor * 1.5)

		this.planetsGroup.add(planetEdge)
	}
	addPlanetEdge() {
		const planets = this.planetsGroup.getChildren()
		const lastPlanet = planets[planets.length - 1]

		const planetEdge = this.add
			.image(
				lastPlanet.x +
				(lastPlanet.width * this.scaleFactor) / 2 -
				650 * this.scaleFactor,
				lastPlanet.y,
				"planetEdge",
			)
			.setScale(this.scaleFactor * 4.5)

		this.planetsGroup.add(planetEdge)
	}

	handleCameraEffects() {
		this.cameras.main.fadeIn(150, 0, 0, 0)
	}

	showInstructionsIfNeeded() {
		console.log("Select Current Planet: " + this.currentPlanet)
		if (this.completedPlanets < 1) {
			displayInstructions(
				this,
				"Click the highlighted planet to get started!",
				14,
				450,
				50,
			)
		} else {
			displayInstructions(
				this,
				"Click the highlighted planet to start your next mission!",
				14,
				450,
				50,
			)
		}

		if (this.completedPlanets >= 3) {
			displayInstructions(
				this,
				"Press on any of the previously completed planets to replay them!",
				14,
				500,
				50,
			)
		}

		// DEBUG: Add screen tap to test planet 2 animation
		// this.input.on('pointerdown', (pointer) => {
		// 	// Check if clicking on background (not a planet)
		// 	if (!pointer.downElement || pointer.downElement.tagName === 'CANVAS') {
		// 		console.log("DEBUG: Playing unlock animation for Planet 2")
		// 		const planet2Index = (2 - 1) * 2 // Planet 2 is at index 2 in the group (0,1,2,3...)
		// 		const planet2 = this.planetsGroup.getChildren()[planet2Index]
				
		// 		if (planet2) {
		// 			console.log("DEBUG: Found planet 2 at position:", planet2.x, planet2.y)
		// 			playUnlockPlanetAnimation(this, {
		// 				xPos: planet2.x,
		// 				yPos: planet2.y,
		// 			}, () => {
		// 				console.log("DEBUG: Planet 2 unlock animation completed")
		// 			})
		// 		} else {
		// 			console.log("DEBUG: Planet 2 not found at index", planet2Index)
		// 			console.log("DEBUG: Available planets:", this.planetsGroup.getChildren().length)
		// 		}
		// 	}
		// })
	}

	updatePlanetStatus(planetId, newStatus) {
		// Find planet in JSON
		let planet = this.userData.planets.find((p) => p.id === planetId)
		if (planet) {
			planet.status = newStatus
			// Save updated data
			this.saveUserData()
		}
	}

	saveUserData() {
		// For local testing - use localStorage
		localStorage.setItem("userData", JSON.stringify(this.saveUserData))
		console.log("Planet Saved User Data:", this.saveUserData)

		// In production with a server:
		// this.saveToServer(this.userData);
	}
}